/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react' 

function useClickOutside (myRef: React.MutableRefObject<null>, callback: (bool:boolean) => void, timeOut: number=-1) {
    const handleClickOutside = (e: Event) =>
    {
        const domNode: any = myRef.current
        // console.log( domNode?.contains ? !domNode.contains(e.target) : "--false--"  )
        if ( !domNode || ( domNode?.contains ? !domNode.contains(e.target) : false ) ) { 
            //clearTimeout( timeOut )
            callback(false)
        }
    }
    useEffect(() =>
    {
        window.document.body.addEventListener("mouseup", handleClickOutside)
        return () => {
            window.document.body.removeEventListener("mouseup", handleClickOutside)
            //clearTimeout( timeOut )
        }
    }, [ myRef ])
} 

export default useClickOutside